module.exports = __webpack_public_path__ + "static/media/storage-tank.cf442b16.svg";